import React from 'react';
import { observer } from 'mobx-react-lite';
import { chartStore } from '../../../store/chartStore';
import { RenderOdd } from './renderOdd';

export const CurrentOdd = observer(() => {
  const { isStarted, isRoundFinish } = chartStore;

  return (
    isStarted &&
    !isRoundFinish && (
      <div className='crash-game-coefficient-num'>
        <RenderOdd />
      </div>
    )
  );
});
